// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaMapMarkerAlt, FaCalendarAlt, FaClock, FaCar } from 'react-icons/fa';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import { getUserAsync } from '../../../app/user/userSlice';

import jwtDecode from 'jwt-decode';
import { IDecodedUser } from '../../../interfaces/user';
import { getToken } from '../../../utils/localStorage';
import { formatDateTime } from '../../../utils/datetimeFomatter';

export const CarRentalHistory = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.user);

  const tk = getToken();
  let d: IDecodedUser;
  let uid = 0;
  if (tk !== null) {
    d = jwtDecode(tk);
    uid = d.sub;
  }

  useEffect(() => {
    dispatch(getUserAsync(uid));
  }, [dispatch, uid]);

  const rentals = userInfo?.bookings
    ?.filter((quote?: any) => {
      return (
        quote?.status === 'Transaction Paid' ||
        (quote?.payment.length > 0 && quote?.payment[0]?.status === 'Transaction Paid')
      );
    })
    .sort((a: any, b: any) => {
      const aCreatedAt = new Date(a.createdAt).getTime();
      const bCreatedAt = new Date(b.createdAt).getTime();
      return bCreatedAt - aCreatedAt;
    });

  return (
    <div className='history-page'>
      <h2 className='history-heading'>Car Rental Bookings</h2>

      {!rentals || rentals.length === 0 ? (
        <div className='history-empty'>
          <FaCar className='history-empty-icon' />
          <h4>No rental bookings yet</h4>
          <p>Your confirmed rental bookings will appear here.</p>
        </div>
      ) : (
        <div className='history-cards'>
          {rentals.map((quote: any, index: number) => {
            const startDateTime = new Date(quote?.startDate);
            const { formattedDate: formattedStartDate } = formatDateTime(startDateTime);
            const endDateTime = new Date(quote?.endDate);
            const { formattedDate: formattedEndDate } = formatDateTime(endDateTime);
            const durationText = quote?.duration === 1 ? 'day' : 'days';

            return (
              <div key={index} className='history-card'>
                <div className='history-card-header'>
                  <span className='history-card-number'>#{quote?.bookingNumber}</span>
                  <span className='history-badge history-badge-success'>{quote?.payment[0]?.status}</span>
                </div>
                <div className='history-card-body'>
                  <div className='history-card-detail'>
                    <FaMapMarkerAlt className='history-card-icon' />
                    <span>
                      {quote?.pickUpTown === quote?.drivingToTown ? (
                        <>Within {quote?.pickUpTown}</>
                      ) : (
                        <>{quote?.pickUpTown} &rarr; {quote?.drivingToTown}</>
                      )}
                    </span>
                  </div>
                  <div className='history-card-detail'>
                    <FaCalendarAlt className='history-card-icon' />
                    <span>{formattedStartDate} &mdash; {formattedEndDate}</span>
                  </div>
                  <div className='history-card-detail'>
                    <FaClock className='history-card-icon' />
                    <span>{quote?.duration} {durationText}</span>
                  </div>
                </div>
                <Link to={`/dashboard/quotations/${quote?.id}`} className='history-card-action'>
                  <FaEye className='me-1' /> View Details
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
